module.exports = __webpack_public_path__ + "close_white-v1-2ca824d3.svg";